import React, {useState} from "react";
import { useForm } from "react-hook-form";
import './App.css';
import Login from "./Login";
import RemoteStatus from "./utils/RemoteStatus";



const StatusPage = () => {


  return (
    <div className="App">


    <RemoteStatus address={'192.168.178.80'} port={3389}/>




    </div>
  );
}

export default StatusPage;
